import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { sellerimg, seller_img } from "../../constants";
import "../../assets/css/level.css";

const Levels = () => {
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* level pageHeader starts here */}
			<section className="about_pageheader">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="pageheader-content-wrapper">
								<h2>Seller levels at Apricot</h2>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* level pageHeader ends here */}
			{/* levels sec starts here */}
			<section className="levels-sec">
				<div className="container">
					<div className="row box-row">
						<div className="col-lg-5">
							<div className="heading-wrapper">
								<h2 className="text-end">What are seller levels?</h2>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="level-description">
								<div className="text-section">
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Iusto veniam debitis doloribus officia ad, dolor consequatur
										saepe aperiam nihil facilis consectetur corrupti distinctio
										nesciunt fugiat.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="row box-row">
						<div className="col-lg-5">
							<div className="heading-wrapper">
								<h2>
									{" "}
									<span>
										<img src={sellerimg} alt="" />
									</span>{" "}
									New Seller
								</h2>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="level-description">
								<div className="text-section">
									<h3>Overview</h3>
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Iusto veniam debitis doloribus officia ad, dolor consequatur
										saepe aperiam nihil facilis consectetur corrupti distinctio
										nesciunt fugiat.
									</p>
								</div>
							</div>
							<div className="level-description">
								<div className="text-section">
									<h3>You’ll get to:</h3>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="row box-row">
						<div className="col-lg-5">
							<div className="heading-wrapper">
								<h2>
									{" "}
									<span>
										<img src={sellerimg} alt="" />
									</span>{" "}
									Level 1
								</h2>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="level-description">
								<div className="text-section">
									<h3>Overview</h3>
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Iusto veniam debitis doloribus officia ad, dolor consequatur
										saepe aperiam nihil facilis consectetur corrupti distinctio
										nesciunt fugiat.
									</p>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
							<div className="level-description">
								<div className="text-section">
									<h3>You’ll get to:</h3>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="row box-row">
						<div className="col-lg-5">
							<div className="heading-wrapper">
								<h2>
									{" "}
									<span>
										<img src={sellerimg} alt="" />
									</span>{" "}
									Level 2
								</h2>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="level-description">
								<div className="text-section">
									<h3>Overview</h3>
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Iusto veniam debitis doloribus officia ad, dolor consequatur
										saepe aperiam nihil facilis consectetur corrupti distinctio
										nesciunt fugiat.
									</p>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
							<div className="level-description">
								<div className="text-section">
									<h3>You’ll get to:</h3>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="row box-row">
						<div className="col-lg-5">
							<div className="heading-wrapper">
								<h2>
									{" "}
									<span>
										<img src={sellerimg} alt="" />
									</span>{" "}
									Best Seller
								</h2>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="level-description">
								<div className="text-section">
									<h3>Overview</h3>
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Iusto veniam debitis doloribus officia ad, dolor consequatur
										saepe aperiam nihil facilis consectetur corrupti distinctio
										nesciunt fugiat.
									</p>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
							<div className="level-description">
								<div className="text-section">
									<h3>You’ll get to:</h3>
									<ul>
										<li>Lorem, ipsum dolor sit amet</li>
										<li>Lorem, ipsum dolor sit amet consectetur</li>
										<li>Lorem, ipsum dolor sit amet consectetur adipisi</li>
										<li>Lorem, ipsum dolor sit</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* levels sec ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Levels;
